/* eslint-disable max-len */
import React, { SVGAttributes } from 'react';

export const RibbonStar = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='25' height='28' viewBox='0 0 25 28' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M5.45023 15.5557L1.11133 20.8582L5.21289 21.6785L6.85352 26.6004L11.2187 19.6747'
      fill='var(--dcm-account-icon-fill)'
    />
    <path
      d='M5.45023 15.5557L1.11133 20.8582L5.21289 21.6785L6.85352 26.6004L11.2187 19.6747'
      stroke='var(--dcm-account-icon-stroke)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.3242 15.5557L23.6631 20.8582L19.5615 21.6785L17.9209 26.6004L13.5557 19.6747'
      fill='var(--dcm-account-icon-fill)'
    />
    <path
      d='M19.3242 15.5557L23.6631 20.8582L19.5615 21.6785L17.9209 26.6004L13.5557 19.6747'
      stroke='var(--dcm-account-icon-stroke)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.0419 2.25015L15.0953 3.82621L17.7291 3.70089C17.9191 3.6919 18.1066 3.74525 18.2605 3.85208C18.4144 3.95891 18.5254 4.11279 18.5751 4.28819L19.2644 6.72026L21.4724 8.1009C21.6327 8.20078 21.7523 8.35018 21.8112 8.52414C21.8701 8.69811 21.8647 8.88611 21.7959 9.05674L20.8565 11.406L21.7959 13.7594C21.8635 13.9294 21.8682 14.1162 21.8094 14.2891C21.7505 14.462 21.6316 14.6104 21.4724 14.71L19.2644 16.0906L18.5751 18.5227C18.5254 18.6981 18.4144 18.8519 18.2605 18.9588C18.1066 19.0656 17.9191 19.119 17.7291 19.11L15.0953 18.9846L13.0419 20.565C12.8936 20.6788 12.709 20.7409 12.5188 20.7409C12.3285 20.7409 12.144 20.6788 11.9957 20.565L9.94224 18.9815L7.30846 19.1068C7.11832 19.1158 6.93065 19.0625 6.77657 18.9557C6.62249 18.8489 6.51125 18.695 6.46129 18.5195L5.77311 16.0874L3.56514 14.7068C3.40543 14.6077 3.28616 14.4592 3.22728 14.2862C3.16839 14.1132 3.17345 13.9261 3.24161 13.7562L4.17994 11.406L3.24161 9.05142C3.17222 8.88086 3.16651 8.69267 3.22545 8.51855C3.28438 8.34444 3.40435 8.19506 3.56514 8.09559L5.77311 6.71495L6.46129 4.28288C6.51125 4.1074 6.62249 3.95348 6.77657 3.84667C6.93065 3.73985 7.11832 3.68654 7.30846 3.69558L9.94224 3.82621L11.9957 2.25015C12.144 2.13629 12.3285 2.07422 12.5188 2.07422C12.709 2.07422 12.8936 2.13629 13.0419 2.25015Z'
      fill='var(--dcm-account-icon-accent)'
      stroke='var(--dcm-account-icon-stroke)'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.0981 6.73986C12.2708 6.39531 12.7666 6.39531 12.9393 6.73986L14.1034 9.06227C14.1718 9.19871 14.3032 9.29335 14.4553 9.31566L17.0432 9.69542C17.4272 9.75176 17.5804 10.2192 17.3032 10.4885L15.4347 12.3036C15.3249 12.4102 15.2747 12.5634 15.3003 12.7136L15.7356 15.2707C15.8002 15.6501 15.3991 15.939 15.055 15.7609L12.7362 14.5602C12.5999 14.4897 12.4375 14.4897 12.3012 14.5602L9.98236 15.7609C9.63833 15.939 9.23718 15.6501 9.30177 15.2707L9.73713 12.7136C9.76271 12.5634 9.71252 12.4102 9.60274 12.3036L7.73422 10.4885C7.45701 10.2192 7.61024 9.75176 7.99419 9.69542L10.5821 9.31566C10.7342 9.29335 10.8656 9.19871 10.934 9.06227L12.0981 6.73986Z'
      fill='var(--dcm-account-icon-fill)'
    />
  </svg>
);
